const types = {
  IS_LOADING_CLIENTS: "IS_LOADING_CLIENTS",
  UPDATE_CLIENT_LIST: "UPDATE_CLIENT_LIST",
  UPDATE_YEAR: "UPDATE_YEAR",
  ADD_CLIENT_TO_LIST: "ADD_CLIENT_TO_LIST"
};

export default types;
